/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */
import { getHeaders, handleResponse } from '@opengeoweb/api';
import type { Credentials } from '@opengeoweb/authentication';
import { sessionStorageProvider } from '@opengeoweb/shared';
import type { TrajksFormValues } from '../components/Trajks';

const getPublisherBaseUrl = (): string => {
  const config = sessionStorageProvider.getConfig();
  return config?.GW_KNMI_PUBLISHER_BASE_URL || '';
};

export const publishProduct = async (
  auth: Credentials,
  data: TrajksFormValues,
  productType = 'trajks',
): Promise<Headers | null> => {
  const publisherBaseUrl = getPublisherBaseUrl();
  return fetch(`${publisherBaseUrl}/publish/${productType}`, {
    headers: getHeaders(auth),
    method: 'POST',
    body: JSON.stringify(data),
  }).then(handleResponse) as Promise<Headers | null>;
};
